import { put, call, all, takeLatest, select } from 'redux-saga/effects'
import services from '../../services'

import {
  GetOneInspection,
  GET_ONE_INSPECTION,
  GET_ONE_INSPECTION_ERROR,
  GET_ONE_INSPECTION_SUCCESS,
} from '../types/inspection/get-one'

import {
  GetAllInspections,
  GET_ALL_INSPECTIONS,
  GET_ALL_INSPECTIONS_ERROR,
  GET_ALL_INSPECTIONS_SUCCESS,
} from '../types/inspection/get-all'

import {
  NewInspection,
  NEW_INSPECTION,
  NEW_INSPECTION_ERROR,
  NEW_INSPECTION_SUCCESS,
} from '../types/inspection/new'

import {
  EditInspection,
  EDIT_INSPECTION,
  EDIT_INSPECTION_ERROR,
  EDIT_INSPECTION_SUCCESS,
} from '../types/inspection/edit'

import {
  DeleteInspection,
  DELETE_INSPECTION,
  DELETE_INSPECTION_ERROR,
  DELETE_INSPECTION_SUCCESS,
} from '../types/inspection/delete'

import {
  GetInspectionsMetrics,
  GET_INSPECTIONS_METRICS,
  GET_INSPECTIONS_METRICS_ERROR,
  GET_INSPECTIONS_METRICS_SUCCESS,
} from '../types/inspection/get-metrics'

import {
  GET_LAST_INSPECTION,
  GET_LAST_INSPECTION_ERROR,
  GET_LAST_INSPECTION_SUCCESS,
} from '../types/inspection/get-last'

const currentAllInspectionsStore = ({ inspectionStore }) => inspectionStore.all.data

function* getOneInspection({ payload }) {
  try {
    const { response, error } = yield call(services.inspection.getOne, payload)

    if (error) {
      yield put({
        type: GET_ONE_INSPECTION_ERROR,
        payload: error,
      })
    } else {
      yield put({
        type: GET_ONE_INSPECTION_SUCCESS,
        payload: response,
      })
    }
  } catch {
    yield put({
      type: GET_ONE_INSPECTION_ERROR,
      payload: 'Error al obtener una inspeccion',
    })
  }
}

function* getAllInspections({ payload }) {
  try {
    const { response, error } = yield call(services.inspection.getAll, payload)
    if (error) {
      yield put({
        type: GET_ALL_INSPECTIONS_ERROR,
        payload: error?.response?.status,
      })
    } else {
      yield put({
        type: GET_ALL_INSPECTIONS_SUCCESS,
        payload: response,
      })
    }
  } catch {
    yield put({
      type: GET_ALL_INSPECTIONS_ERROR,
      payload: 'Error al obtener todas las inspecciones',
    })
  }
}

function* newInspection({ payload }) {
  try {
    const { response, error } = yield call(services.inspection.new, payload)

    if (error) {
      yield put({
        type: NEW_INSPECTION_ERROR,
        payload: error?.response?.status,
      })
    } else {
      const newInspection = response
      const currentAllInspections = yield select(currentAllInspectionsStore);

      // Iterar sobre cada grupo en allInspections
      for (const group of currentAllInspections) {
        // Iterar sobre los resultados dentro del grupo
        for (const result of group.results) {
          // Verificar si el cliente coincide
          if (result.customer._id === response?.customer?._id) {
            // Agregar la nueva inspección a la lista de inspecciones del cliente
            result.inspections.push(newInspection);
          }
        }
      }

      yield all([
        put({
          type: NEW_INSPECTION_SUCCESS,
          payload: response,
        }),
        put({
          type: GET_ALL_INSPECTIONS_SUCCESS,
          payload: currentAllInspections,
        }),
      ])
    }
  } catch {
    yield put({
      type: NEW_INSPECTION_ERROR,
      payload: 'Error al crear una nueva inspeccion',
    })
  }
}

function* editInspection({ payload }) {
  try {
    const { response, error } = yield call(services.inspection.edit, payload)
    if (error) {
      yield put({
        type: EDIT_INSPECTION_ERROR,
        payload: error?.response?.status,
      })
    } else {
      yield all([
        put({
          type: EDIT_INSPECTION_SUCCESS,
          payload: response,
        }),
        put({
          type: GET_ONE_INSPECTION_SUCCESS,
          payload: response,
        }),
      ])
    }
  } catch {
    yield put({
      type: EDIT_INSPECTION_ERROR,
      payload: 'Error al editar una inspeccion',
    })
  }
}

function* deleteInspection({ payload }) {
  try {
    const { response, error } = yield call(services.inspection.deleteOne, payload)
    if (error) {
      yield put({
        type: DELETE_INSPECTION_ERROR,
        payload: error?.response?.status,
      })
    } else {
      const currentAllInspections = yield select(currentAllInspectionsStore);

      for (const group of currentAllInspections) {
        // Iterar sobre los resultados dentro del grupo
        for (const result of group.results) {
          // Buscar y eliminar la inspección del cliente
          result.inspections = result.inspections.filter(
            (inspection) => {
              return inspection._id !== payload?.idInspection
            }
          );
        }
      }

      yield all([
        put({
          type: DELETE_INSPECTION_SUCCESS,
          payload: response,
        }),
        put({
          type: GET_ALL_INSPECTIONS_SUCCESS,
          payload: currentAllInspections,
        }),
      ])
    }
  } catch {
    yield put({
      type: DELETE_INSPECTION_ERROR,
      payload: 'Error al eliminar una inspeccion',
    })
  }
}

function* getMetrics({ payload }) {
  try {
    const { response, error } = yield call(services.inspection.getMetrics, payload)
    if (error) {
      yield put({
        type: GET_INSPECTIONS_METRICS_ERROR,
        payload: error?.response?.status,
      })
    } else {
      yield put({
        type: GET_INSPECTIONS_METRICS_SUCCESS,
        payload: response,
      })
    }
  } catch {
    yield put({
      type: GET_INSPECTIONS_METRICS_ERROR,
      payload: 'Error al obtener metricas de las inspecciones',
    })
  }
}

function* getLastInspection({ payload }) {
  console.log("SAGA getLastInspection", payload)
  try {
    const { response, error } = yield call(services.periodicCheck.getLast, payload)
    if (error) {
      yield put({
        type: GET_LAST_INSPECTION_ERROR,
        payload: error
      })
    } else {
      yield put({
        type: GET_LAST_INSPECTION_SUCCESS,
        payload: response,
      })
    }
  } catch {
    yield put({
      type: GET_LAST_INSPECTION_ERROR,
      payload: 'Error al obtener una la última inspección',
    })
  }
}

/**
 * Watchers
 */
export default function* applicant() {
  yield takeLatest<GetOneInspection>(GET_ONE_INSPECTION, getOneInspection)
  yield takeLatest<GetAllInspections>(GET_ALL_INSPECTIONS, getAllInspections)
  yield takeLatest<GetOneInspection>(GET_LAST_INSPECTION, getLastInspection)
  yield takeLatest<NewInspection>(NEW_INSPECTION, newInspection)
  yield takeLatest<EditInspection>(EDIT_INSPECTION, editInspection)
  yield takeLatest<DeleteInspection>(DELETE_INSPECTION, deleteInspection)
  yield takeLatest<GetInspectionsMetrics>(GET_INSPECTIONS_METRICS, getMetrics)
}
